export default {
  "content": "<path d=\"M4.057.39a.4.4 0 01.56-.015l5.025 4.68c.225.21.35.505.35.81-.005.305-.135.6-.365.805l-4.99 4.475a.4.4 0 01-.56-.025l-.445-.48a.403.403 0 01.025-.57l4.715-4.22-4.75-4.42a.399.399 0 01-.015-.57l.45-.47z\" fill=\"#8A8F9E\"/>",
  "attrs": {
    "width": "12",
    "height": "12",
    "viewBox": "0 0 12 12",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};